import { render, staticRenderFns } from "./answers.vue?vue&type=template&id=7614c5c2"
import script from "./answers.vue?vue&type=script&lang=js"
export * from "./answers.vue?vue&type=script&lang=js"
import style0 from "./answers.vue?vue&type=style&index=0&id=7614c5c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports